import { connect } from 'react-redux';
import { SimpleInputField } from '../../../components/SimpleInputField';
import {
    mapDispatchToPersonalEmailProps,
    mapDispatchToPersonalPhoneNumberProps,
    mapStateToPersonalEmailProps,
    mapStateToPersonalPhoneNumberProps,
} from './personalElement';

export const PersonalEmailContainer = connect(
    mapStateToPersonalEmailProps,
    mapDispatchToPersonalEmailProps
)(SimpleInputField);

export const PersonalPhoneNumberContainer = connect(
    mapStateToPersonalPhoneNumberProps,
    mapDispatchToPersonalPhoneNumberProps
)(SimpleInputField);
